import { updateProfile, getMyProfile, activateOnCard, getUploadAvatarUrl, uploadDone, getPublicProfile, getUploadPublicProfile, validateNationalId } from "api/user";
import { useMutation } from "react-query";

function useGetMyProfile() {
  return useMutation(getMyProfile, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useUpdateProfile() {
  return useMutation(updateProfile, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useValidateNationalId() {
  return useMutation(validateNationalId, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useActivateOnCard() {
  return useMutation(activateOnCard, {
  });
}

function useGetPublicProfile() {
  return useMutation(getPublicProfile, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useGetUploadAvatarUrl() {
  return useMutation(getUploadAvatarUrl, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useUploadAvatarDone() {
  return useMutation(uploadDone, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useUploadPublicProfile() {
  return useMutation(getUploadPublicProfile, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

export { useUpdateProfile, useGetMyProfile, useActivateOnCard, useGetUploadAvatarUrl, useUploadAvatarDone, useGetPublicProfile, useUploadPublicProfile, useValidateNationalId };
